import { createNomogramWidget } from './shared/nomogram.js';
import fields from './shared/fields.js';
import colors from './shared/colors.js';

const erectileFunctionWidgetApp = createNomogramWidget({
    dataApi: '/umbraco/api/erectilefunction/calculate',
    errorMessage: 'Failed to calculate erectile function',
    chartColors: [
        colors.red,
        colors.orange,
        colors.yellow,
        colors.lightGreen,
        colors.green,
    ],
    fields: [
        fields.Age,
        fields.FP,
        fields.IIEFEF,
        fields.ProstateSize,
        fields.IPSS,
        fields.BMI,
    ],
    payload: vm => ({
        Age: vm.Age,
        FP: vm.FP,
        IIEFEF: vm.IIEFEF,
        ProstateSize: vm.ProstateSize,
        IPSS: vm.IPSS,
        BMI: vm.BMI,
    }),
});

export default erectileFunctionWidgetApp;
